import axios from './axios';

const API_URL = '/api/settings/billing';

export const getBillingConfig = async () => axios.get(API_URL);
export const updateBillingConfig = async (payload) => axios.put(API_URL, payload);
export const getBillingPreview = async (payload = {}) => axios.get(`${API_URL}/preview`, { params: payload });
export const getBillingComponents = async () => axios.get(`${API_URL}/components`);
export const createBillingComponent = async (payload) => axios.post(`${API_URL}/components`, payload);
export const updateBillingComponent = async (id, payload) => axios.put(`${API_URL}/components/${id}`, payload);
export const deleteBillingComponent = async (id) => axios.delete(`${API_URL}/components/${id}`);
